var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 24",
    id: "Layer_24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,12H6a1,1,0,0,1-1-1V7A1,1,0,0,1,6,6h4a1,1,0,0,1,1,1v4A1,1,0,0,1,10,12ZM7,10H9V8H7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,8.47V11h4V8.47a2.11,2.11,0,0,1-2,1A2.11,2.11,0,0,1,6,8.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,15.47V18h4V15.47a2.11,2.11,0,0,1-2,1A2.11,2.11,0,0,1,21,15.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,22.47V25h4V22.47a2.11,2.11,0,0,1-2,1A2.11,2.11,0,0,1,6,22.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29,10H10a1,1,0,0,1,0-2H29a1,1,0,0,1,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,10H3A1,1,0,0,1,3,8H6a1,1,0,0,1,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,26H6a1,1,0,0,1-1-1V21a1,1,0,0,1,1-1h4a1,1,0,0,1,1,1v4A1,1,0,0,1,10,26ZM7,24H9V22H7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,24H3a1,1,0,0,1,0-2H6a1,1,0,0,1,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29,24H10a1,1,0,0,1,0-2H29a1,1,0,0,1,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,19H21a1,1,0,0,1-1-1V14a1,1,0,0,1,1-1h4a1,1,0,0,1,1,1v4A1,1,0,0,1,25,19Zm-3-2h2V15H22Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,17H3a1,1,0,0,1,0-2H21a1,1,0,0,1,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29,17H25a1,1,0,0,1,0-2h4a1,1,0,0,1,0,2Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.80d0d4f80b4b1a1be56b138e97c2f405.svg";
export { ForwardRef as ReactComponent };